import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';

/**
 * @group
 * @component
 *
 * @export
 * @class LsqReportActionsLayoutComponent
 */
@Component({
    selector: 'lsq-report-actions-layout',
    template: `
        <div class="report-actions-layout row">
            <div class="report-actions-col col-{{ bootstrapWidth }}">
                <ng-content></ng-content>
            </div>
        </div>
    `,
    styleUrls: ['./lsq-report-actions-layout.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class LsqReportActionsLayoutComponent implements OnInit {
    @Input() public layoutWidth: 'sm' | 'md' | 'lg' = 'lg';
    public bootstrapWidth: string;
    public ngOnInit(): void {
        switch (this.layoutWidth) {
            case 'sm':
                this.bootstrapWidth = 'md-4';
                break;
            case 'md':
                this.bootstrapWidth = 'md-6';
                break;
            default:
                this.bootstrapWidth = 'md-12';
                break;
        }
    }
}
